import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ReportDownloadButton from '../common/ReportDownloadButton';
import DownloadForMultipleStudents from './DownloadForMultipleStudents';
import useReports from 'state/hooks/use-reports';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { FONT_GSS_FUTURA_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';

const t = (key: string, options?) => translate('reports', key, options);

const StudentCharacterReportHeader: React.FC = () => {
  const classes = useStyles();
  const [{ selectedStudent }] = useReports();

  if (!selectedStudent) return null;
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Typography variant="h2" className={classes.gridTitle} gutterBottom={true}>
        {`${selectedStudent.firstName} ${selectedStudent.lastName}`}
      </Typography>
      <Box display="flex" justifyContent="space-between" gap={'1rem'} className="noPrint">
        <DownloadForMultipleStudents />
        <ReportDownloadButton text={t('downloadStudentReport')} />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  gridTitle: {
    fontSize: remCalc(32),
    lineHeight: remCalc(48),
    fontFamily: FONT_GSS_FUTURA_BOLD,
  },
}));

export default StudentCharacterReportHeader;
